// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination_pagination_1xsiO","info":"Pagination_info_2cUbo","perPageSelector":"Pagination_perPageSelector_CN8cp"};